import { privateGateway } from '../../../config';

export const confirmUserRequest = async (requestId: string): Promise<void> => {
  await privateGateway(
    process.env.REACT_APP_USER_CONTROLLER_API_GATEWAY as string
  ).post(`/user_requests/${requestId}`);
};
